__webpack_require__.p = "/yandex_delivery/couriers_dreamers_club/_next/";